<template>
  <div class="container-fluid py-3 px-4">

    <!-- TÍTULO CARGA DE CESADOS -->
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-text display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            CESADOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            CARGA DE CESADOS (INDIVIDUAL)
          </p>
        </div>
      </div>
    </div>

    <!-- OPCIONES -->
    <div class="col-md-12">

      <button class="btn btn-secondary mt-2 ms-2" @click="CargaTrabajadores"
        title="Opción para cargar trabajadores que pasarán por una nueva renovación">
        <i class="bi bi-database-fill-up"></i>
      </button>

      <button class="btn btn-danger mt-2 ms-2"
        title="Opción para desbloquear el listado de trabajadores cuando ya se esta realizando una renovación INDIVIDUAL"
        @click="Indi">
        <i class="bi bi-unlock-fill"></i>
      </button>



      <button class="btn btn-success mt-2 ms-2" title="Opción para ir a cese MASIVA de trabajadores"
        @click="$router.push('/RegistroCeseMasivo')">
        <i class="bi bi-people"></i>
      </button>



      <button @click="descargarExcel" :class="{
        'btn btn-success mt-2 ms-2':
          !excelCarga,
        'btn btn-outline-success mt-2 ms-2':
          excelCarga,
      }" :disabled="!excelCarga"> <i class="bi bi-filetype-xls"></i>
        <b v-if="excelCarga"></b>
        <b v-else>CARGANDO...</b>
      </button>
    </div>



    <div class="mt-2 pb-2">
      <div class="border border-1 rounded-3 p-3 mb-3  shadow-sm">

        <!-- 🔹 Título -->
        <div class="d-flex align-items-center mb-3">
          <i class="bi bi-funnel-fill fs-4 text-primary me-2"></i>
          <h4 class="fw-bold text-dark mb-0">FILTROS DE BÚSQUEDA: </h4>
        </div>

        <!-- 🔹 Campos de búsqueda -->
        <div class="row gy-3 gx-3">

          <!-- 🧍‍♂️ DOC IDENTIDAD -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-vcard text-danger fs-5"></i> DOC. IDENTIDAD:
            </label>
            <b-input v-model.trim="Dni" placeholder="BUSQ. POR DOC. IDENTIDAD" @input="Dni = Dni.replace(/\s+/g, '');"
              @keydown.space.prevent></b-input>
          </div>

          <!-- 👤 APELLIDOS -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person text-success fs-5"></i> APELLIDOS:
            </label>
            <b-input v-model.trim="Apellidos" placeholder="BUSQ. POR APELLIDOS"
              @input="Apellidos = Apellidos.replace(/^\s+/, '');"
              @keydown.space="Apellidos.length === 0 && $event.preventDefault()"></b-input>
          </div>

          <!-- 🏢 CLIENTE -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-diagram-3-fill text-info fs-5"></i> SUB SUBCENTRO:
            </label>
            <b-input v-model.trim="SubSubCentro" placeholder="BUSQ. POR SUB SUBCENTRO"
              @input="SubSubCentro = SubSubCentro.replace(/^\s+/, '');"
              @keydown.space="SubSubCentro.length === 0 && $event.preventDefault()"></b-input>
          </div>
        </div>
      </div>
    </div>


    <!-- 🔹 Contador y Botón de Acción Masiva -->
    <div class="card shadow-sm mb-3 border-3">

      <div class="d-flex justify-content-end mt-3 mx-2 gap-2 align-items-center">
        <!-- 🔹 Botón de Acción Masiva -->
        <button v-if="seleccionadosMasivo.length > 0" 
                class="btn btn-success fw-bold shadow-sm d-flex align-items-center gap-2" 
                @click="registerSelected" 
                :disabled="isProcessingBatch">
          <i class="bi bi-check-all fs-5"></i>
          REGISTRAR SELECCIONADOS
        </button>

        <div
          class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
          <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
          <span class="fw-bold text-primary">
            Total de trabajadores: {{ ItemsCese.length }}
          </span>
        </div>
      </div>

      <div class="mt-2 mx-2 table-responsive">
        <table v-if="primeraTabla" class="table table-bordered reducirTamaño">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-center text-white text-nowrap">
              <th colspan="5">DATOS GENERALES</th>
              <th colspan="8">CESE</th>
              <th colspan="1"></th>
            </tr>

            <tr class="bg-solimano text-white reducirTamaño text-center align-middle text-nowrap">
              <th>
                <!-- 🔹 Recuadro de Selección Masiva IDENTICO a RegRenIndividual -->
                <div @click="MarcarTodos()"
                  :class="seleccionadosMasivo.length > 0 ? 'bg-dark border-white' : 'bg-white border-white'"
                  style="cursor: pointer; width: 12px; height: 12px; border: 1px solid; display: inline-block; border-radius: 2px; transition: 0.2s;"></div>
              </th>
              <th>PERIODO</th>
              <th>PROYECTO</th>
              <th>TRABAJADOR</th>
              <th>CONTRATO ACTUAL</th>
              <th>FECHA </th>
              <th>MOTIVO</th>
              <th>COMENTARIO</th>
              <th>TAREO DIARIO</th>
              <th>BONIFICACIONES.</th>
              <th>DESCUENTO</th>
              <th>HORAS EXTRA</th>
              <th>MOVILIDAD</th>

              <th>REGISTRAR</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center align-middle text-nowrap reducirTamaño" v-for="itema in itemsCesePaginados"
              :key="itema.idCese" :class="{ 'selected-row': itema.idCese === selectedItemId }">

              <td class="text-center">
               
                <input type="checkbox" v-model="itema.accionCese" :disabled="isdisabled2"
                  @change="actualizarEstado(itema)" />
              </td>

              <!-- PERIODO -->
              <td class="text-start ">
                <label>{{ itema.periodo }}</label>
                <br>
                <i :class="{
                  ' bi bi-arrow-clockwise text-primary': itema.cesCodEstado == 'EN PROCESO',
                  'bi bi-check-circle-fill text-warning': itema.cesCodEstado == 'SOLICITADO',
                  'bi bi-x-circle-fill text-danger': itema.cesCodEstado == 'NO RENOVADO',
                }"></i>
                <label :class="{
                  'text-primary': itema.cesCodEstado == 'EN PROCESO',
                  'text-warning': itema.cesCodEstado == 'SOLICITADO',
                  'text-danger': itema.cesCodEstado == 'NO RENOVADO',
                }">
                  {{ itema.cesCodEstado }}
                </label>
              </td>
              <!-- PROYECTO -->
              <td class="text-start">
                <small><strong>  {{ itema.nomEmpresa }}</strong>  </small> <br>
                <small class="text-muted">{{ itema.subCentroCostos }}</small><br>
                <small class="text-muted">{{ itema.subSubCentroCostos }}</small>
              </td>

              <!-- TRABAJADOR -->
              <td class="text-start">
                <small><strong>{{ itema.nomTrabajador }}</strong></small><br>
                <small class="text-muted">{{ itema.codTrabajador }}</small><br>
                <small class="text-muted">{{ itema.nroDocumento }}</small>
              </td>

              <!-- CONTRATO -->
              <td class="text-start">
                <i class="bi bi-briefcase-fill text-primary me-1"></i>
                <small><strong>{{ itema.nomPuesto }}</strong></small><br>
                <i class="bi bi-calendar-event text-success me-1"></i>
                <small>
                  {{ new Date(itema.fechaIniContrato).toLocaleDateString('es-ES') }}
                  -
                  <i class="bi bi-calendar-event text-danger me-1"></i>
                  {{ new Date(itema.fechaFinContrato).toLocaleDateString('es-ES') }}
                </small><br>
                <i class="bi bi-cash-coin text-success me-1"></i>
                <small>SUELDO: {{ itema.cesSueldo }}</small> <br>
                <i class="bi bi-people-fill text-warning me-1"></i>
                <small>ASIG FAMILIAR: {{ itema.asignacionFamiliar }}</small>

              </td>

              <!-- FECHA CESE -->
              <td class="text-center">
                <!-- <input v-if="motivoCese == '003' && itema.idCese === selectedItemId" :disabled="isdisabled2"
                  class="form-control form-control-sm text-center text-secondary no-margin" 
                  type="date" :value="motivoCese === '003' && itema.idCese === selectedItemId
                    ? itema.fechaFinContrato.slice(0, 10)
                    : itema.fechaCese.slice(0, 10)
                    "
                    style="font-size: 10px; height: 22px; padding: 0px 5px; width: 120px; min-height: 22px;"
                     /> -->
                    

                     <label for="">{{ fechaActual.split('-').reverse().join('/') }}</label>
                     <!-- v-else  -->
                <!-- <input class="form-control form-control-sm text-center text-secondary no-margin" type="date" :value="fechaActual"
                  :max="itema.fechaFinContrato.slice(0, 10)" @input="
                    checkMaxDate($event, itema.fechaFinContrato.slice(0, 10))
                    " disabled
                    style="font-size: 10px; height: 22px; padding: 0px 5px; width: 120px; min-height: 22px;"
                    /> -->
           
             
              </td>


              <!-- MOTIVO -->
              <td class="text-center">
                <span v-if="itema.motivoCese">{{ itema.motivoCese }}</span>
                <span v-else class="text-muted">-</span>
              </td>

              <!-- ADJUNTO -->
              <!-- <td>
                <div class="d-flex justify-content-center py-0 my-0 me-2">
                  <button class="btn btn-light text-danger py-0 my-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                      class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                      <path
                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                      <path
                        d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
                    </svg>
                  </button>
                  <label for="file-upload" class="custom-file-upload my-0 py-0 me-0 ms-2" v-if="
                    itema.accionCese &&
                    (motivoCese == '001' ||
                      motivoCese == '005' ||
                      motivoCese == '007')
                  ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                      class="bi bi-arrow-down-circle-fill my-0 py-0 text-primary" viewBox="0 0 16 16">
                      <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
                    </svg>
                  </label>
                  <input v-if="
                    itema.accionCese &&
                    (motivoCese == '001' ||
                      motivoCese == '005' ||
                      motivoCese == '007')
                  " type="file" id="file-upload" ref="fileInput" style="display: none" accept=".pdf" class="mx-0"
                    @change="handleFileUpload" />
                  <button v-if="
                    selectedFile != null &&
                    itema.idCese === selectedItemId &&
                    documentoSubir
                  " :class="{
                    'text-white btn btn-success my-0 ms-1 w-100 mx-0 py-0 border border-2':
                      selectedFile != null,
                  }" @click="uploadPDF">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                    </svg>
                  </button>
                </div>
              </td>-->

              <!-- COMENTARIO -->
              <td>
                <span v-if="itema.comentario">{{ itema.comentario }}</span>
                <span v-else class="text-muted">-</span>
              </td>

              <!-- DÍAS -->
              <td>
                <div class="small d-flex justify-content-between text-secondary">
                  <span>TRAB.</span>
                  <small class="fw-semibold text-primary">{{ itema.diasTrabajados }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <span>FALTAS</span>
                  <small class="fw-semibold text-danger">{{ itema.diasFaltas }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <span>DESC.</span>
                  <small class="fw-semibold text-warning">{{ itema.diasDescansoMedico }}</small>
                </div>
                <div class="small d-flex justify-content-between text-secondary">
                  <span>VACACIONES</span>
                  <small class="fw-semibold text-warning">{{ itema.diasVacaciones }}</small>
                </div>
                <div class="small d-flex justify-content-between text-secondary">
                  <small>MES ANTERIOR</small>
                  <small class="fw-semibold text-primary">{{ itema.diasMesAnterior }}</small>
                </div>
                <div class="small d-flex justify-content-between text-secondary">
                  <small>D.FERIADOS</small>
                  <small class="fw-semibold text-primary">{{ itema.feriadoTrabajado }}</small>
                </div>
                <div class="small d-flex justify-content-between border-top pt-1 mt-1">
                  <span class="fw-bold text-dark">TOTAL</span>
                  <small class="fw-bold text-dark">{{ itema.totalDias }}</small>
                </div>
              </td>


              <!-- BONOS -->
              <td>
                <div class="small d-flex justify-content-between text-secondary">
                  <small>AGUINALDO</small>
                  <small class="fw-semibold text-success">{{ itema.aguinaldo }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>ALIMENTOS</small>
                  <small class="fw-semibold text-success">{{ itema.alimentos }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>BONO. NOCT.</small>
                  <small class="fw-semibold text-primary">{{ itema.bonoNocturno }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>BONO. REG.</small>
                  <small class="fw-semibold text-primary">{{ itema.bonoRegular }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>COMISIÓN</small>
                  <small class="fw-semibold text-primary">{{ itema.comision }}</small>
                </div>
              </td>


              <!-- DESCUENTOS -->
              <td class="text-start">
                <div class="small d-flex justify-content-between text-secondary">
                  ALMACÉN:
                  <small class="fw-semibold text-danger">{{ itema.desAlmacen }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  BIENESTAR:
                  <small class="fw-semibold text-danger">{{ itema.desBienestar }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  CONTABILI:
                  <small class="fw-semibold text-danger">{{ itema.desContabiliad }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  TI:
                  <small class="fw-semibold text-danger">{{ itema.desTecnologia }}</small>
                </div>
              </td>


              <!-- HORAS EXTRA -->
              <td>
                <div class="small d-flex justify-content-between text-secondary">
                  <small>25%</small>
                  <small class="fw-semibold text-success">{{ itema.horaExtra25 }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>35%</small>
                  <small class="fw-semibold text-success">{{ itema.horaExtra35 }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>50%</small>
                  <small class="fw-semibold text-warning">{{ itema.horaExtra50 }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>100%</small>
                  <small class="fw-semibold text-danger">{{ itema.horaExtra100 }}</small>
                </div>
              </td>


              <!-- MOVILIDAD -->
              <td>
                <div class="small d-flex justify-content-between text-secondary">
                  <small>MOVILIDAD</small>
                  <small class="fw-semibold text-primary">{{ itema.movilidad }}</small>
                </div>

                <div class="small d-flex justify-content-between text-secondary">
                  <small>MOV. EXTRA</small>
                  <small class="fw-semibold text-primary">{{ itema.movilidadExtra }}</small>
                </div>
              </td>



              <!-- REGISTRAR -->
              <td class="text-center">
                <button class="btn btn-outline-success btn-sm" :disabled="!itema.accionCese" @click="abrirModal(itema)">
                  <i class="bi bi-pencil-fill"></i>
                </button>

                <button @click="CambiosGestion(itema.idCese)" class="btn btn-outline-primary btn-sm ms-1" :disabled="!itema.accionCese">
                  <i class="bi bi-check-circle"></i>
                </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      
      <div v-if="totalPages > 1"
        class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info fw-semibold">
          Página {{ currentPage }} de {{ totalPages }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>

    </div>

    <div>
      <b-modal v-model="showModal" title="Calendario" size="xl" modal-class="custom-modal">
        <!-- <div class="d-flex"> -->
        <!-- <div class="calendar-left me-3">
          <b-calendar v-model="selectedDate" mode="month"  @change="updateDays"            :date-disabled="disableDays"
@input="updateDays"></b-calendar>
        </div> 

        <div class="container"> 
        <div class="row">
          <div v-for="day in dias" :key="day.numero" :class="['days', 'col', 'col-3', 'border', 'border-1']">
            Dia {{ day.numero }}
            <select @change="motivoXdia($event, itema)" class="form-control text-cente ms-1r"
              id="exampleFormControlSelect1" required :disabled="day.deshabilitado">
              <option disabled selected>seleccionar...</option>
              <option v-for="regimen in regimenPensionario" :key="regimen.id" :value="regimen.parCorrelativo">
                {{ regimen.parCadAlterno1 }}
              </option>
            </select>
          </div>
        </div>-->
        <!-- </div> -->

        <!-- </div> -->
      </b-modal>
      <div v-if="showEditModal" class="modal-backdrop fade show" style="z-index:1050;" @click="showEditModal = false">
      </div>
      <div v-if="showEditModal" class="modal fade show d-block" tabindex="-1" style="z-index:1055">

        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" @click.stop>

          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title fw-bold text-uppercase w-100 text-center">
                REGISTRAR INFORMACIÓN DE CESE
              </h5>
              <button class="btn-close" @click="showEditModal = false"></button>
            </div>

            <!-- BODY -->
            <div class="modal-body" v-if="itemEditable">
              <form @submit.prevent="Registro(itemEditable)">

                <!-- FILA 1 -->
                <div class="row gx-3 gy-3">
                  <div class="col-md-3">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-x-circle text-danger fs-7 me-1"></i> <small>MOTIVO DEL CESE</small> 
                    </label>
                    <select required class="form-control tamañoInput text-secondary"
                      @change="itemEditable.codigoMotivo = $event.target.value; calcularDiasAutomaticos('motiveChange')">
                      <!-- OPCIÓN MOSTRADA (bonita) -->
                      <option selected disabled>
                       {{ itemEditable.motivoCese || '-- SELECCIONAR MOTIVO --' }}
                      </option>

                      <!-- OPCIONES REALES -->
                      <option v-for="m in motivo" :key="m.id" :value="m.parCorrelativo">
                        {{ m.parDescripcion }}
                      </option>
                    </select>

                  </div>

                  <div class="col-md-2">
                    <label class="form-label tamaño d-flex align-items-center ">
                      <i class="bi bi-calendar-x text-primary fs-7 me-1"></i> <small>FECHA CESE</small>
                    </label>
                    <input type="date" class="form-control tamañoInput" v-model="itemEditable.fechaCese"
                      :max="itemEditable.fechaFinContrato?.slice(0, 10)" @change="calcularDiasAutomaticos" required />

                  </div>

                  <div class="col-md-3">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 me-1"></i><small>COMENTARIO</small>
                    </label>
                    <input type="text" class="form-control tamañoInput" v-model="itemEditable.comentario">

                  </div>
                  <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-arrow-repeat text-primary fs-7 me-1"></i><small>TOT. DIAS</small>
                    </label>
                    <input class="form-control bg-light tamañoInput" type="number" id="totalDias" v-model="itemEditable.totalDias"
                      disabled="" />
                  </div>

                    <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center ">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i> <small>DÍAS TRAB.</small> </label>
                    <input class="form-control bg-light tamañoInput" v-model="itemEditable.diasTrabajados" readonly disabled>
                  </div>

                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>DÍAS FALT.</small></label>
                    <input class="form-control tamañoInput" 
                      v-model.number="itemEditable.diasFaltas" 
                      @input="calcularDiasAutomaticos('diasFaltas')"
                      type="number" min="0" />
                  </div>

                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>DM.</small></label>
                    <input class="form-control tamañoInput" 
                      v-model.number="itemEditable.diasDescansoMedico"
                      @input="calcularDiasAutomaticos('diasDescansoMedico')" 
                      type="number" min="0">
                  </div>

                    <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-calendar-check text-info fs-7 tamaño me-1"></i><small> DIAS VAC.</small>
                    </label>
                   <input class="form-control tamañoInput" 
                      v-model.number="itemEditable.diasVacaciones"
                      @input="calcularDiasAutomaticos('diasVacaciones')" 
                      type="number" min="0" />
                  </div>

                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i> <small>BON. REG.</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.bonoRegular">
                  </div>


                    <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i> <small>BON. NOCT.</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.bonoNocturno">
                  </div>


                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i> <small>COMIS.</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.comision">
                  </div>


                     <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>ALIM.</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.alimentos">
                  </div>


                      <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>MOV.</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.movilidad">
                  </div>
                  
                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center ">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>HE 25%</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.horaExtra25">
                  </div>

                  
                  <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>HE 35%</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.horaExtra35">
                  </div>

                  <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center gap-2">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>HE 50%</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.horaExtra50">
                  </div>

                   <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-chat-square-text text-success fs-7 tamaño me-1"></i><small>HE 100%</small></label>
                    <input class="form-control tamañoInput" v-model="itemEditable.horaExtra100">
                  </div>

                  
                  <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-arrow-left-right text-warning fs-7 tamaño me-1"></i> <small>D.M. ANT.</small> 
                    </label>
                    <input type="number" class="form-control tamañoInput" v-model="itemEditable.diasMesAnterior" />
                  </div>


                  
                  <div class="col-md-1">
                    <label class="form-label tamaño d-flex align-items-center">
                      <i class="bi bi-arrow-repeat text-primary fs-7 tamaño me-1"></i> <small>DÍAS FER.</small>
                    </label>
                    <input type="number" class="form-control tamañoInput" v-model="itemEditable.feriadoTrabajado">
                  </div>


                  
                  <div class="col-md-6">
                    <label class="form-label  d-flex align-items-center tamaño me-1">
                      <i class="bi bi-file-earmark-pdf text-danger fs-7"></i><small>
                        ADJUNTAR DOCUMENTO
                      </small>
                    </label>

                    <!-- <input id="fileInput" type="file" class="form-control" accept=".pdf" ref="fileInputModal"
                      @change="uploadPDF" /> -->
                    <!-- handleFileUploadModal -->


                  <!-- ADJUNTO -->
              
                <div class="d-flex py-0 my-0 ">
                 
                  <a v-if="itemEditable.cesEstadoAdjunto" :href="itemEditable.cesAdjunto" target="_blank"  class=" text-dark">
                    <i class="bi bi-file-earmark-pdf btn btn-danger py-0 my-0"></i>
                  </a>

                <button v-else class="btn btn-light text-danger py-0 my-0" disabled>
                  <i class="bi bi-file-earmark-pdf"></i>
                </button>

                  <label @click="selectedItemId = itemEditable.idCese" for="file-upload" class="custom-file-upload my-0 py-0 me-0 ms-2" >
                    <i class="bi bi-arrow-up-circle-fill text-primary fs-5"></i>
                  </label>
                  <input 
                   type="file" id="file-upload" multiple ref="fileInput" style="display: none" accept=".pdf" class="mx-0"
                    @change="handleFileUpload($event)" />
                  <!-- <button 
                   :class="{
                    'text-white btn btn-success my-0 ms-1 w-100 mx-0 py-0 border border-2':
                      selectedFile != null,
                  }" >
                   @click="Registro"
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                    </svg> 
                  </button> -->
                </div>
            
                  </div>
                </div>

                            <!-- ACCIONES -->
                <div class="modal-actions mt-4 d-flex justify-content-end gap-2">
                  <button type="button" class="btn btn-secondary px-4" @click="showEditModal = false">
                    Cancelar
                  </button>

                  <button type="submit" class="btn btn-primary px-4">
                    Guardar
                  </button>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "SolimanologRegistroDeCeseIndividual",

  data() {
    return {
      showModal: false,
      // selectedDate: new Date().toISOString().substr(0, 10), // Convertir a formato de fecha ISO
      daysInMonth: [],
      dias: [],
      totalDias: 31, // Total de días en el mes
      showEditModal: false,
      itemEditable: null,
      mensajeNumero: "",
      idRenovacion: "",
      checkeId: [],
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      documentos: [],
      primeraTabla: true,
      segundaTabla: false,
      terceraTabla: false,
      excelCarga: false,
      excel: [],

      idTrabajador: "",

      from: {
        idRenovacion: "",
      },

      motivo: [],
      regimenPensionario: [],
      masisvo: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      puesto: [],
      dniUsuario: "",
      idEmpresa: "",
      cenCodigoCentro: "",
      cenCodigoSubCentro: "",
      cenCodigoSubSubCemtro: "",
      codRenMotivo: "",
      fechaIni: "1900-01-01",
      fechaFin: "1900-01-01",
      idPuesto: "0",
      sueldo: 0,
      sueldoFinal: 0,
      sueldoCargo: 0,

      isdisabled: false,
      selectedItemId: null, // ID del ítem seleccionado
      motivoCese: "",
      selectedFile: null,
      documentoSubir: false,
      desabilitado: false,

      calcularTrab: 0,
      isProcessingBatch: false, // Para deshabilitar el botón de acción masiva durante el procesamiento
      fechaFormato: "",
      currentPage: 1,
      itemsPerPage: 15,
      isdisabled2: false,
      permisoVisualizador: "",
      idUsario: "",
    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.idUsario = localStorage.getItem("userId");


    this.axios.get("ParametroData/Parametro/7683").then(r => {
      this.motivo = r.data;
    });

    this.axios.get("ParametroData/Parametro/7672").then(r => {
      this.regimenPensionario = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then(r => {
      this.puesto = r.data;
    });


    const fechaActual = new Date();
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0");
    const año = fechaActual.getFullYear();

    this.fechaFormato = `${dia}/${mes}/${año}`;
  },
  created() {
    this.RegistroCese();
    this.reporteRenovacion();
    this.cambiarEstadoNavbar();
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["ItemsCese"]),

    itemsCeseFiltrados() {
      const data = Array.isArray(this.ItemsCese) ? this.ItemsCese : [];

      const dni = (this.Dni || "").toString().toLowerCase();
      const apellidos = (this.Apellidos || "").toLowerCase();
      const subCentro = (this.SubSubCentro || "").toLowerCase();

      return data.filter(item => {
        return (
          (!dni || item.nroDocumento?.toString().toLowerCase().includes(dni)) &&
          (!apellidos || item.nomTrabajador?.toLowerCase().includes(apellidos)) &&
          (!subCentro || item.subSubCentroCostos?.toLowerCase().includes(subCentro))
        );
      });
    },

    itemsCesePaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.itemsCeseFiltrados.slice(start, start + this.itemsPerPage);
    }
    ,

    totalPages() {
      return Math.ceil(this.itemsCeseFiltrados.length / this.itemsPerPage);
    },

    fechaActual() {
      const now = new Date();
      const dia = String(now.getDate()).padStart(2, "0");
      const mes = String(now.getMonth() + 1).padStart(2, "0");
      const anio = now.getFullYear();
      return `${anio}-${mes}-${dia}`;
    },

    seleccionadosMasivo() {
      const data = Array.isArray(this.ItemsCese) ? this.ItemsCese : [];
      return data.filter(item => item.accionCese == true);
    }
  },
 
  watch: {
    Dni() {
      this.currentPage = 1;
    },
    Apellidos() {
      this.currentPage = 1;
    },
    SubSubCentro() {
      this.currentPage = 1;
    }
  },
  methods: {
    ...mapActions("renovaciones", ["RegistroCese"]),

    MarcarTodos() {
      // 1. Verificamos si todos los filtrados ya están marcados
      const todosMarcados = this.itemsCeseFiltrados.every(item => item.accionCese == true);

      // 2. Si todos están marcados, la acción es desmarcar (0), de lo contrario marcar (1)
      const nuevaAccion = todosMarcados ? "0" : "1";

      // 3. Obtenemos los IDs
      const ids = this.itemsCeseFiltrados.map(item => item.idCese).join(',');

      if (!ids) return;

      // Mostramos spinner de carga
      Swal.fire({
        title: 'Procesando',
        text: 'Por favor espere mientras se actualiza la selección...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const data = {
        idCeses: ids, // Usar idCeses para el endpoint de Cese
        accion: nuevaAccion
      };
      console.log(data)

      // Llamada al endpoint masivo de Ceses
      this.axios.put("Cese/CambioEstadoGeneralxCese", data) // Asumiendo este endpoint para Ceses
        .then(res => {
          if (res.data) {
            // 4. Actualizamos la vista localmente para que los checks cambien
            this.itemsCeseFiltrados.forEach(item => {
              item.accionCese = (nuevaAccion === "1");
            });
            
            Swal.fire({
              title: nuevaAccion === "1" ? '¡Seleccionado!' : '¡Desmarcado!',
              text: nuevaAccion === "1" ? 'Se han seleccionado todos los registros.' : 'Se han desmarcado todos los registros.',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          }
        })
        .catch(err => {
          console.error(err);
          Swal.fire('Error', 'Ocurrió un problema al procesar la solicitud.', 'error');
        });
    },

    async registerSelected() {
      if (this.seleccionadosMasivo.length === 0) {
        await Swal.fire("Advertencia", "No hay trabajadores seleccionados para registrar.", "warning");
        return;
      }

      const result = await Swal.fire({
        title: '¿Registrar seleccionados?',
        text: `Se procesarán ${this.seleccionadosMasivo.length} ceses.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, registrar todos'
      });

      if (!result.isConfirmed) return;

      this.isProcessingBatch = true;
      for (const item of this.seleccionadosMasivo) {
        await this.Registro(item); // Llama al método de registro individual para cada elemento seleccionado
      }
      this.isProcessingBatch = false;
      await Swal.fire("Éxito", "Registro masivo completado.", "success");
    },

    checkMaxDate(event, itema) {
      const fechaSeleccionada = new Date(event.target.value);
      const fechaMax = new Date(itema);

      if (fechaSeleccionada >= fechaMax) {
        event.target.value = itema;
      }
    },
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    // handleFileUploadModal(event) {
    //   const file = event.target.files[0];

    //   if (!file) return;

    //   // 1. Validar formato
    //   if (file.type !== "application/pdf") {
    //     Swal.fire("Error", "Solo se permite archivos PDF", "error");
    //     event.target.value = "";
    //     return;
    //   }

    //   // 2. Validar tamaño (5MB = 5 * 1024 * 1024 bytes)
    //   const maxSize = 5 * 1024 * 1024;
    //   if (file.size > maxSize) {
    //     Swal.fire("Archivo muy pesado", "El PDF no debe superar los 5MB", "warning");
    //     event.target.value = "";
    //     this.selectedFile = null;
    //     return;
    //   }

    //   this.selectedFile = file;
    //   console.log("Archivo listo para subir:", file.name);
    // },
    // handleFileUploadModal(event) {
    //   const file = event.target.files[0];

    //   if (!file) return;

    //   if (file.type !== "application/pdf") {
    //     Swal.fire("Error", "Solo se permite archivos PDF", "error");
    //     event.target.value = "";
    //     return;
    //   }

    //   this.selectedFile = file;
    // },
    // openFileDialog() {
    //   this.$refs.fileInput.click();
    // },

   
   CambiosGestion(idCese) {
      this.axios
        .put(`Cese/CambiarEstadoGestion?idCese=${idCese}`)
        .then((response) => {
          console.log("Gestión modificada:", response.data);
          this.RegistroCese(); // Refrescar la lista después de actualizar
        })
        .catch((error) => {
          console.error("Error al modificar gestión:", error);
        });
    },

  handleFileUpload(event) {
  // 1. Obtenemos la lista completa de archivos seleccionados
  let files = event.target.files;

  // Validamos que al menos se haya seleccionado un archivo
  if (files && files.length > 0) {
    const formData = new FormData();

    // 2. RECORREMOS TODOS LOS ARCHIVOS Y LOS AGREGAMOS AL FORMDATA
    for (let i = 0; i < files.length; i++) {
      formData.append("Archivo", files[i]);
    }   
    // Agregamos los campos que mapean con tu modelo de C# para el SP
    formData.append("idTrabajador", this.itemEditable.idTrabajador); // <-- ¡OJO! Asegúrate de pasar el idTrabajador real aquí
    formData.append("tipDoc", '002'); // <-- ¡OJO! Pasa aquí el ID del usuario logueado para tu auditoría (@idUsuario)
    formData.append("idProceso", this.permisoVisualizador); // Tipo de documento opcional (ej: '001', '046', etc.)
    formData.append("idUsuario", this.idUsario); // <-- ¡OJO! Asegúrate de pasar el idCese real aquí
    console.log("ID Cese seleccionado:", this.selectedItemId);

    // 4. Enviamos la petición HTTP PUT con Axios
    this.axios
      .put("Cese/AdjuntoCese", formData)
      .then((response) => {
        console.log("Respuesta del servidor:", response.data);
        alert("Archivos cargados correctamente: " + response.data);
        
        // Limpiamos el input si es necesario
        event.target.value = ''; 
      })
      .catch((error) => {
        console.error("Error en servidor:", error.response ? error.response.data : error.message);
        alert("Error al subir archivos: " + error.message);
      });
  }
},

    actualizarEstado(items) {
      console.log(items);
      this.from.idCese = items.idCese; // Use idCese for Cese module

      // Lógica de búsqueda de centros de costo al marcar (igual que en RegRenIndividual)
      for (let index of this.ItemsCese) { // Use ItemsCese for Cese module
        if (index.idCese == items.idCese) { // Use idCese for Cese module
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.cesCodCC}&codSubCentro=${index.cesCodScc}` // Use cesCodCC, cesCodScc for Cese module
            )
            .then((r) => {
              this.SubSubCentroCosto = r.data;
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      this.axios.put("Cese/ModificarAccionCese", { idCese: items.idCese, accionCese: items.accionCese }).then((r) => {
        console.log(r);
      });
    },
    estaDeshabilitado(idCese) {
      // return (
      //   this.selectedItemId !== null &&
      //   this.selectedItemId !== idCese &&
      //   this.ItemsCese.find((item) => item.idCese === this.selectedItemId)
      //     .accionCese
      // );
      if (!this.selectedItemId) return false;

      const selectedItem = this.ItemsCese.find(
        (item) => item.idCese === this.selectedItemId
      );

      if (!selectedItem || typeof selectedItem.accionCese === "undefined") {
        return false;
      }

      return idCese !== this.selectedItemId && selectedItem.accionCese;
    },

    motivoXdia(event, items, nombreColumna) {
      console.log(event.target.value);
      console.log(items.idCese);
      console.log(nombreColumna);

      this.axios
        .put(
          `Cese/CambioCesDia?idCese=${items.idCese}&columnName=${nombreColumna}&newValue=${event.target.value}`
        )
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            Swal.fire("Se registró", "", "success");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showModales(itema) {
      this.dias = [];
      this.showModal = true;
      console.log(itema.fechaCese.slice(8, 10));
      let dias = itema.fechaCese.slice(8, 10);

      for (let index = 0; index < this.totalDias; index++) {
        this.dias.push({
          numero: index + 1,
          deshabilitado: index >= dias, // Deshabilitar días mayores o iguales a 'dias'
        });
        console.log(this.dias);
      }
    },
    abrirModal(itema) {
      this.itemEditable = JSON.parse(JSON.stringify(itema));
      this.itemEditable.fechaCese = this.fechaActual;
      // this.motivoCese = this.itemEditable.codigoMotivo;
       console.log("item editable", this.itemEditable);
      this.$nextTick(() => {
        this.calcularDiasAutomaticos();
      });

      this.showEditModal = true;
    },


    calcularDiasAutomaticos(sourceOfChange) { // Renombrado para mayor claridad
      if (!this.itemEditable?.fechaCese || !this.itemEditable?.fechaFinContrato) {
        // No se puede validar si las fechas no están definidas
        return;
      }

      const fechaCeseDate = new Date(this.itemEditable.fechaCese);
      const fechaFinContratoDate = new Date(this.itemEditable.fechaFinContrato);
      const motivo = this.itemEditable.codigoMotivo;

      // --- Proactive Info Alerts (when motive is first selected) ---
      // Solo mostrar esta alerta informativa cuando el selector de motivo cambia.
      if (sourceOfChange === 'motiveChange') {
        if (motivo === '001') { // Renuncia
          Swal.fire("Consideración Importante", "Para 'Renuncia', la fecha de cese debe ser como máximo un (01) día antes de la fecha de término de contrato. Recuerde verificar el preaviso de 30 días.", "info");
        } else if (motivo === '002') { // Cese por Periodo de Prueba
          Swal.fire("Recordatorio", "Para este motivo debe adjuntar la Carta de Comunicación y la evidencia del correo enviado.", "info");
        } else if (motivo === '003') { // Vencimiento de Contrato
          Swal.fire("Consideración Importante", "Para el motivo 'Vencimiento de Contrato', la fecha de cese debe ser <b>exactamente</b> la fecha de término del contrato.", "info");
        } else if (motivo === '004') { // Fallecimiento
          Swal.fire("Recordatorio", "Para este motivo debe adjuntar el Certificado de Defunción y/o la comunicación formal de Bienestar Social.", "info");
        } else if (motivo === '005') { // Abandono de Trabajo
          Swal.fire({
            title: "Abandono de Trabajo / Inasistencia",
            html: "Para este motivo debe acreditar:<br>1. Control de asistencia (inasistencias injustificadas).<br>2. Requerimiento de justificación al trabajador.<br>3. Carta de despido por abandono.<br>4.Aprobación de Gerencias<br>Es obligatorio adjuntar el reporte y comunicaciones.</b>",
            icon: "info"
          });
        } else if (motivo === '006') { // Despido
          Swal.fire({
            title: "Procedimiento Disciplinario (RIT)",
            html: "Para <b>Despido</b> debe cumplir:<br>1. Notificación de preaviso.<br>2. Plazo de 6 días para descargos.<br>3. Carta de despido.<br>4.Aprobación de Gerencias<br><b>Es obligatorio adjuntar el expediente completo.</b>",
            icon: "info"
          });
        }
      }

      // --- Date Validations and Corrections ---

      // 1. Validación general: La fecha de cese no puede ser posterior a la fecha de fin de contrato
      if (fechaCeseDate > fechaFinContratoDate) {
        Swal.fire(
          "Advertencia",
          "La fecha de cese no puede ser posterior a la fecha de fin de contrato.",
          "warning"
        );
        this.itemEditable.fechaCese = this.itemEditable.fechaFinContrato.slice(0, 10);
        return; // Detener el resto de validaciones de fecha si la general falla
      }

      // 2. Validaciones de fecha específicas por motivo
      if (motivo === '001') { // Renuncia
        if (fechaCeseDate >= fechaFinContratoDate) {
          Swal.fire(
            "Advertencia",
            "Para el motivo 'Renuncia', la fecha de cese debe ser como máximo un (01) día antes de la fecha de término de contrato.",
            "warning"
          );
          const oneDayBeforeFinContrato = new Date(fechaFinContratoDate);
          oneDayBeforeFinContrato.setDate(fechaFinContratoDate.getDate() - 1);
          this.itemEditable.fechaCese = oneDayBeforeFinContrato.toISOString().slice(0, 10);
        }
      } else if (motivo === '003') { // Vencimiento de Contrato
        if (this.itemEditable.fechaCese !== this.itemEditable.fechaFinContrato.slice(0, 10)) {
          Swal.fire(
            "Fecha Incorrecta",
            "Para el motivo 'Vencimiento de Contrato', la fecha de cese debe ser exactamente la fecha de término del contrato.",
            "warning"
          );
          this.itemEditable.fechaCese = this.itemEditable.fechaFinContrato.slice(0, 10);
        }
      } else if (motivo === '002') { // Cese por Periodo de Prueba
        const fechaInicio = new Date(this.itemEditable.fechaIniContrato);
        const limiteProbacion = new Date(fechaInicio);
        limiteProbacion.setMonth(fechaInicio.getMonth() + 3); // Límite de 3 meses

        if (fechaCeseDate > limiteProbacion) {
          Swal.fire(
            "No aplica Periodo de Prueba",
            `El trabajador ya superó los 3 meses de prueba (Límite: ${limiteProbacion.toLocaleDateString('es-ES')}).`,
            "warning"
          );
          this.itemEditable.fechaCese = limiteProbacion.toISOString().slice(0, 10);
          return;
        }
      }


      // --- Lógica existente para el cálculo de días (después de las validaciones de fecha) ---
      // Obtener el límite del mes (día de la fecha de cese)
      const limiteMaximo = parseInt(this.itemEditable.fechaCese.split("-")[2], 10);
      this.itemEditable.totalDias = limiteMaximo; // El total de días del mes hasta la fecha de cese

      // Obtener valores actuales de ausencias (asegurando que sean números)
      let faltas = Number(this.itemEditable.diasFaltas) || 0;
      let descanso = Number(this.itemEditable.diasDescansoMedico) || 0;
      let vacaciones = Number(this.itemEditable.diasVacaciones) || 0;

      // Validar si la suma de ausencias excede el total de días del mes hasta la fecha de cese
      if ((faltas + descanso + vacaciones) > limiteMaximo) {
        Swal.fire(`¡Atención!`, `La suma de ausencias no puede superar el total de días (${limiteMaximo}).`, "warning");
        // Resetear el campo que causó el error a 0 para corregir el cálculo
        if (sourceOfChange && sourceOfChange !== 'motiveChange') { // Solo si se cambió un campo específico de ausencia
          this.itemEditable[sourceOfChange] = 0;
        }
        // Volvemos a leer los valores para el cálculo final (con el campo corregido)
        faltas = Number(this.itemEditable.diasFaltas) || 0;
        descanso = Number(this.itemEditable.diasDescansoMedico) || 0;
        vacaciones = Number(this.itemEditable.diasVacaciones) || 0;
      }

      // Calcular días trabajados finales
      this.itemEditable.diasTrabajados = limiteMaximo - (faltas + descanso + vacaciones);
    },


    diaEscogido() {
      console.log("se escogio");
    },

    reporteRenovacion() {
      console.log("aja");
      this.idTrabajador = localStorage.getItem("idTrabajdor");
      this.excelCarga = false;
      this.axios
        .get(`ReportesExcel/RepRegistros?idTrabajador=${this.idTrabajador}`, {
          responseType: "blob",
        })
        .then((response) => {
          this.excelCarga = true;
          this.excel = response.data;
          console.log(response.data, "excel");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteRenovaciones.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    

    CargaTrabajadores() {
      const usuario = localStorage.getItem("userId");
      this.axios
        .get(`Cese/CanTrabajadoresCese?idUsuario=${usuario}`)
        .then((r) => {
          console.log(r.data, "cantidad de trabajadores");
          if (r.status == 200) {
            this.reporteRenovacion();
            if (r.data.canTrabajadores == "0") {
              Swal.fire(`No se cargo ningún trabajador`, "", "success");
            } else if (r.data.canTrabajadores == "1") {
              Swal.fire(
                `Se registro ${r.data.canTrabajadores}  trabajador`,
                "",
                "success"
              );
            } else {
              Swal.fire(
                `Se registraron ${r.data.canTrabajadores}  trabajadores`,
                "",
                "success"
              );
            }
          }

          this.RegistroCese();
        });
    },

    Indi() {
      this.masivo = false;
      this.isdisabled2 = false;
    },

    Motivos(event) {
      this.codRenMotivo = event.target.value;
    },

    SubSubCentroCostosManda(event) {
      this.cenCodigoSubSubCemtro = event.target.value;
      console.log(event.target.value);
    },

    Puesto(index) {
      const puestos = this.puesto[index - 1];
      this.idPuesto = puestos.idPuesto;
      this.sueldoCargo = puestos.rangoSueldo;

      console.log(puestos);
    },

    FechaIni(event) {
      this.fechaIni = event.target.value;
      console.log(event.target.value);
    },

    FechaFin(event) {
      this.fechaFin = event.target.value;
    },
  Registro(items) {
    console.log(items);
    const fd = new FormData();

    // 🔹 VALIDACIÓN DE DOCUMENTO PARA MOTIVO '005' (Abandono de Trabajo)
    if (items.codigoMotivo === '005') {
      if (!this.selectedFile && !items.cesEstadoAdjunto) {
        Swal.fire("Documentos Requeridos", "Debe adjuntar el reporte de asistencia y el sustento del proceso de abandono (comunicaciones/despido) para proceder.", "warning");
        return;
      }
    }

    // 🔹 VALIDACIÓN DE DOCUMENTO PARA MOTIVO '006' (Despido)
    if (items.codigoMotivo === '006') {
      if (!this.selectedFile && !items.cesEstadoAdjunto) {
        Swal.fire("Documentos Requeridos", "Debe adjuntar el expediente completo (Preaviso, Descargos y Carta de Despido) para proceder.", "warning");
        return;
      }
    }

    // 🔹 VALIDACIÓN DE DOCUMENTO PARA MOTIVO '004' (Fallecimiento)
    if (items.codigoMotivo === '004') {
      if (!this.selectedFile && !items.cesEstadoAdjunto) {
        Swal.fire("Documento Requerido", "Debe adjuntar el Certificado de Defunción o comunicación de Bienestar Social para proceder.", "warning");
        return;
      }
    }

    // 🔹 VALIDACIÓN DE DOCUMENTO PARA MOTIVO '003' (Vencimiento de Contrato)
    if (items.codigoMotivo === '003') {
      if (!this.selectedFile && !items.cesEstadoAdjunto) {
        Swal.fire("Documento Requerido", "Debe adjuntar el Contrato de Trabajo vigente o última adenda para proceder.", "warning");
        return;
      }
    }

    // 🔹 VALIDACIÓN DE DOCUMENTO PARA MOTIVO '002'
    if (items.codigoMotivo === '002') {
      if (!this.selectedFile && !items.cesEstadoAdjunto) {
        console.log(!this.selectedFile && !items.cesEstadoAdjunto);
        Swal.fire("Documento Requerido", "Debe adjuntar la Carta de Cese y evidencia de comunicación para proceder.", "warning");
        return;
      }
    }
 
    fd.append("idCese", items.idCese);
    fd.append("MotivoCese", items.codigoMotivo);
    fd.append("FechaCese", items.fechaCese);
    fd.append("diasTrabajados", items.diasTrabajados);
    fd.append("diasFaltas", items.diasFaltas);
    fd.append("diasDescansoMedico", items.diasDescansoMedico);
    fd.append("Comision", items.comision);
    fd.append("BonoRegular", items.bonoRegular);
    fd.append("BonoNocturno", items.bonoNocturno);
    fd.append("Movilidad", items.movilidad);
    fd.append("MovilidadExtra", items.movilidadExtra);
    fd.append("Alimentos", items.alimentos);
    fd.append("HoraExtra25", items.horaExtra25);
    fd.append("HoraExtra35", items.horaExtra35);
    fd.append("HoraExtra50", items.horaExtra50);
    fd.append("HoraExtra100", items.horaExtra100);
    fd.append("Comentario", items.comentario || "");
    fd.append("diasMesAnterior", items.diasMesAnterior);
    fd.append("feriadoTrabajado", items.feriadoTrabajado);
    fd.append("diasVacaciones", items.diasVacaciones);
    fd.append("AccionCese", true);
    // let estadoAdjunto = (this.selectedFile && items.cesEstadoAdjunto) ? true : false;
    
    // fd.append("cesEstadoAdjunto", estadoAdjunto);

  // console.log("el estado", estadoAdjunto)
    if (this.selectedFile) {
        fd.append("Archivo", this.selectedFile); // El nombre "Archivo" debe ser igual al del C#

    }
 
    // LLAMADA AXIOS (Sin headers manuales)
    this.axios.put("Cese/ModificarCese", fd)
        .then((r) => {
            if (r.data.result === true) {
                Swal.fire("Correcto", "Cese actualizado", "success");
                this.RegistroCese(); // Refrescar tabla
                this.showEditModal = false;
            } else {
                Swal.fire("Error", r.data.mensaje, "error");
            }
        })
        .catch(err => {
            console.error(err);
            Swal.fire("Error", "Error de servidor (415 o 500)", "error");
        });
},
    CargaMasiva() {
      const from = {
        cadenaRenovacion: `${this.checkeId}`,
        idEmpresa: this.idEmpresaMasivo,
        renCodCC: this.cenCodigoCentroMasivo,
        renCodScc: this.cenCodigoSubCentroMasivo,
        renCodSscc: this.cenCodigoSubSubCemtroMasivo,
        idPuesto: this.idPuestoMasivo,
        renSueldo: this.sueldoMasivo,
        fechaIniContrato: this.fechaIniMasivo,
        fechaFinContrato: this.fechaFinMasivo,

      };
      console.log(from);

      this.axios.put("/Renovacion/ModificarRenMasivo", from).then((r) => {
        console.log(r.data);
        this.Renovacion();
        this.checkeId = [];
      });
      //       {
      //   "idRenovacion": 0,
      //   "idEmpresa": 0,
      //   "renCodCC": "string",
      //   "renCodScc": "string",
      //   "renCodSscc": "string",
      //   "idPuesto": 0,
      //   "renSueldo": 0,
      //   "fechaIniContrato": "2023-02-21T22:06:20.213Z",
      //   "fechaFinContrato": "2023-02-21T22:06:20.213Z"
      // }
    },
  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.small-Bar-container,
.line-chart-container,
.stacked-bar-container {
  width: 100%;
  max-width: 250px;
  /* tamaño mediano */
  min-height: 200px;
  /* altura mediana */
  background: white;
  border-radius: 8px;
  padding: 15px;
  margin: 20px auto;
  /* centra horizontalmente en la página */
  display: flex;
  justify-content: center;
  /* centra el gráfico horizontal */
  align-items: center;
  /* centra el gráfico vertical */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-xl-custom {
  max-width: 90%;
}

.modal-ancho-personalizado {
  max-width: 80vw;
  width: 100%;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamañoInput {
  font-size: 0.65rem;

  font-weight: 600;
}

.cursor-pointer {
  cursor: pointer;
}
</style>